import { Component } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface OpcaoModalData {
  titulo: string;
  opcoes: string[];
}

@Component({
  selector: 'app-opcao-impressao-modal',
  templateUrl: './opcao-impressao-modal.component.html',
  styleUrls: ['./opcao-impressao-modal.component.scss']
})

export class OpcaoModalComponent {
  constructor(
    public dialogRef: MatDialogRef<OpcaoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OpcaoModalData
  ) {}

  selecionar(opcao: string) {
    this.dialogRef.close(opcao);
  }
}